import React, { useEffect } from 'react';

const FilterType = (props) => {

  useEffect(() => {
    if (props.filters.type == 'All') {
      document.querySelector('#type-all').checked = true;
    }
    
  }, [props.filters]);;

  return (
    <div className='filter-radio-input'>
      <div>
        <input type="radio" id="type-all" name="type" value="All" onChange={props.handleTypeFilter} />
        <label htmlFor="type-all">All</label>
      </div>

      {Object.entries(props.types).map(([typeId, type], i) => (
        <div key={i}>
          <input type="radio" id={type} name="type" value={type} onChange={props.handleTypeFilter} />
          <label htmlFor={type}>{type}</label>
        </div>
      ))}
    </div>
  );
};

export default FilterType;